import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { orgCancellationOptions } from './queryKeys';
import envVars from '../../../constants/envVars';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
const useGetEnterpriseCancellationOptions = (props, enabled) => {
    const additional = useQueryRequestParams();
    const id = props.id;
    return useQuery({
        queryFn: () => axios.get(`${envVars.API_COMMERCE_HOSTNAME}organizations/backoffice/cancellation/options/`, { ...additional, params: { ...props } }),
        queryKey: [orgCancellationOptions, id],
        enabled
    });
};
export default useGetEnterpriseCancellationOptions;
